(function () {
  var instances = Object.create(null);

  function teardownInstance(sectionId) {
    var inst = instances[sectionId];
    if (!inst) return;
    if (inst.resizeObserver) {
      inst.resizeObserver.disconnect();
    }
    if (inst.sliderAbort) {
      inst.sliderAbort.abort();
    }
    if (inst.mainAbort) {
      inst.mainAbort.abort();
    }
    delete instances[sectionId];
  }

  function initDesignListMultiple(sectionId) {
    if (!sectionId) return;
    teardownInstance(sectionId);
    const sectionEl = document.querySelector('#shopify-section-' + sectionId);
    if (!sectionEl) return;
    var lastMainAbort = null;
    var lastResizeObserver = null;
    var lastSliderAbort = null;
    function syncInstance() {
      instances[sectionId] = {
        mainAbort: lastMainAbort,
        resizeObserver: lastResizeObserver,
        sliderAbort: lastSliderAbort
      };
    }
    syncInstance();

    const mainAbort = new AbortController();
    lastMainAbort = mainAbort;
    syncInstance();
    const mainSignal = { signal: mainAbort.signal };

  const container = sectionEl.querySelector('.design-list-container');
  const switcher = sectionEl.querySelector('[data-brand-switcher]');
  if (!container) {
    mainAbort.abort();
    lastMainAbort = null;
    syncInstance();
    return;
  }

  function readBrandTabsVisibleSlots() {
    if (!switcher) return 3;
    var raw = switcher.getAttribute('data-brand-tabs-visible');
    var v = parseInt(raw, 10);
    if (!Number.isFinite(v) || v < 1) return 3;
    return Math.min(12, v);
  }
  var brandTabsVisibleSlots = readBrandTabsVisibleSlots();
  var desktopQuery = window.matchMedia('(min-width: 768px)');
  function isMobileWidth() {
    return !desktopQuery.matches;
  }

  function getBrandTabIds() {
    return Array.from(sectionEl.querySelectorAll('.brand-switcher-tab[data-brand-tab]'))
      .map(function (el) {
        return String(el.getAttribute('data-brand-tab') || '');
      })
      .filter(function (id) {
        return id.length > 0;
      });
  }

  function ensureOneActiveBrandPanel() {
    var ids = getBrandTabIds();
    var panels = sectionEl.querySelectorAll('.brand-panel');
    if (!panels.length) return null;
    var targetId = '';
    if (ids.length && ids.indexOf(String(currentBrand)) >= 0) {
      targetId = String(currentBrand);
    } else if (ids.length) {
      targetId = ids[0];
    } else {
      targetId = String(panels[0].getAttribute('data-brand-panel') || '');
    }
    if (!targetId) return null;
    currentBrand = targetId;
    panels.forEach(function (p) {
      p.classList.toggle('is-active', String(p.getAttribute('data-brand-panel')) === targetId);
    });
    sectionEl.querySelectorAll('.brand-switcher-tab[data-brand-tab]').forEach(function (tab) {
      var on = String(tab.getAttribute('data-brand-tab')) === targetId;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    return sectionEl.querySelector('.brand-panel.is-active');
  }

  let brandLayoutRetries = 0;
  const maxBrandLayoutRetries = 48;
  let tabWidthMeasureRetries = 0;
  const maxTabWidthMeasureRetries = 40;

  function layoutBrandSwitcher() {
    if (!switcher) return;
    const labels = switcher.querySelector('.brand-switcher-labels');
    const track = switcher.querySelector('.brand-switcher-tabs-track');
    if (!labels || !track) return;
    const tabs = Array.from(track.querySelectorAll('.brand-switcher-tab[data-brand-tab]'));
    const n = tabs.length;
    if (n === 0) return;
    brandTabsVisibleSlots = readBrandTabsVisibleSlots();
    const tabIdsNow = tabs
      .map(function (t) {
        return String(t.getAttribute('data-brand-tab') || '');
      })
      .filter(function (id) {
        return id.length > 0;
      });
    if (tabIdsNow.length && tabIdsNow.indexOf(String(currentBrand)) < 0) {
      ensureOneActiveBrandPanel();
      mountProductSlider();
    }

    tabs.forEach(function (t) {
      t.style.flex = '';
      t.style.minWidth = '';
      t.style.maxWidth = '';
    });
    labels.style.width = '';
    labels.style.minWidth = '';
    labels.style.maxWidth = '';

    if (n <= brandTabsVisibleSlots) {
      tabWidthMeasureRetries = 0;
      brandLayoutRetries = 0;
      labels.style.removeProperty('width');
      labels.style.removeProperty('max-width');
      labels.style.removeProperty('min-width');
      track.style.transform = 'translateX(0)';
      return;
    }

    const trackCs = window.getComputedStyle(track);
    const gapParsed = parseFloat(trackCs.gap);
    const gapPx = Number.isFinite(gapParsed) ? gapParsed : 10;
    const labelsCs = window.getComputedStyle(labels);
    const padLR = (parseFloat(labelsCs.paddingLeft) || 0) + (parseFloat(labelsCs.paddingRight) || 0);

    if (labels.clientWidth <= 0 && switcher.clientWidth <= 0) {
      if (brandLayoutRetries < maxBrandLayoutRetries) {
        brandLayoutRetries += 1;
        requestAnimationFrame(layoutBrandSwitcher);
      }
      return;
    }
    brandLayoutRetries = 0;

    const prevLabelsWidth = labels.style.width;
    const prevLabelsMaxW = labels.style.maxWidth;
    labels.style.maxWidth = 'none';
    labels.style.width = '99999px';
    void track.offsetWidth;
    const widths = tabs.map(function (t) {
      return t.getBoundingClientRect().width;
    });
    labels.style.width = prevLabelsWidth;
    labels.style.maxWidth = prevLabelsMaxW;

    function sumSegmentWidth(start, count) {
      let sum = 0;
      for (let j = 0; j < count; j += 1) {
        const idx = start + j;
        if (idx >= widths.length) break;
        sum += widths[idx];
        if (j < count - 1) sum += gapPx;
      }
      return sum;
    }

    const ids = tabs.map(function (t) {
      return String(t.getAttribute('data-brand-tab'));
    });
    const i = Math.max(0, ids.indexOf(String(currentBrand)));
    const maxOff = n - brandTabsVisibleSlots;
    const scrollOff = Math.max(0, Math.min(i - 1, maxOff));

    const innerView = sumSegmentWidth(scrollOff, brandTabsVisibleSlots);
    const desiredOuter = innerView + padLR;
    const widthsInvalid = widths.some(function (w) {
      return !(Number.isFinite(w) && w >= 2);
    });
    if (widthsInvalid || !Number.isFinite(innerView) || innerView < 8 || !Number.isFinite(desiredOuter)) {
      labels.style.width = '';
      track.style.transform = 'translateX(0)';
      if (tabWidthMeasureRetries < maxTabWidthMeasureRetries) {
        tabWidthMeasureRetries += 1;
        requestAnimationFrame(layoutBrandSwitcher);
      } else {
        tabWidthMeasureRetries = 0;
      }
      return;
    }
    tabWidthMeasureRetries = 0;
    const minLabelStripPx = 100;
    labels.style.width = Math.max(desiredOuter, minLabelStripPx) + 'px';

    let offsetPx = 0;
    for (let k = 0; k < scrollOff; k += 1) {
      offsetPx += widths[k] + gapPx;
    }
    track.style.transform = 'translateX(' + (-offsetPx) + 'px)';
  }

  const firstBrandTab = sectionEl.querySelector('.brand-switcher-tab[data-brand-tab]');
  let currentBrand = firstBrandTab ? String(firstBrandTab.getAttribute('data-brand-tab') || '') : '';
  ensureOneActiveBrandPanel();
  let slider = null;
  let slide = null;
  let totalSlides = 0;
  let realCount = 0;
  let loopEnabled = false;
  let sliderAbort = new AbortController();
  lastSliderAbort = sliderAbort;
  syncInstance();

  let gap = 0;
  const sensitivity = 1;
  const minDragDistance = 2;
  const minMovementToBlockClick = 3;
  const touchAxisLockThreshold = 4;

  let slideWidth = 0;
  let containerWidth = 0;
  let isDragging = false;
  let isMouseDown = false;
  let startPos = 0;
  let startPosY = 0;
  let dragAxisLocked = null;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let currentIndex = 0;
  let hasMoved = false;
  let justFinishedDrag = false;
  let justFinishedDragTimer = 0;
  let setPositionRetries = 0;
  const maxSetPositionRetries = 60;
  let loopNormalizeTimer = 0;
  let loopNormalizeOnEnd = null;
  const slideTransitionMs = 360;

  function getActivePanel() {
    return sectionEl.querySelector('.brand-panel.is-active');
  }

  function cancelPendingLoopNormalize() {
    if (loopNormalizeTimer) {
      clearTimeout(loopNormalizeTimer);
      loopNormalizeTimer = 0;
    }
    if (loopNormalizeOnEnd && slider) {
      slider.removeEventListener('transitionend', loopNormalizeOnEnd);
      loopNormalizeOnEnd = null;
    }
  }

  function teardownSliderListeners() {
    cancelPendingLoopNormalize();
    if (isMouseDown || isDragging) dragEnd();
    sliderAbort.abort();
    sliderAbort = new AbortController();
    lastSliderAbort = sliderAbort;
    syncInstance();
  }

  function clearInfiniteLoop(sliderEl) {
    if (!sliderEl) return;
    sliderEl.querySelectorAll('.product-item--clone').forEach(function (el) {
      el.remove();
    });
  }

  function prepareLoopClone(clone, sourceItem) {
    clone.classList.add('product-item--clone');
    clone.setAttribute('aria-hidden', 'true');
    // Transform carousels never enter the scroll viewport, so native lazy-load
    // leaves wrap-around clones blank / stuck in is-loading when spamming Next.
    var sourceImgs = sourceItem
      ? sourceItem.querySelectorAll('.product-bg img.product-bg-img')
      : null;
    clone.querySelectorAll('.product-bg img.product-bg-img').forEach(function (img, i) {
      if (img.dataset) {
        delete img.dataset.dlmLoadBound;
        delete img.dataset.dlmRetried;
      }
      var sourceImg = sourceImgs && sourceImgs[i] ? sourceImgs[i] : null;
      var src = (sourceImg && (sourceImg.currentSrc || sourceImg.getAttribute('src')))
        || img.currentSrc
        || img.getAttribute('src')
        || '';
      kickImageRequest(img, src);
      setProductImageLoading(img.closest('.product-bg'), !isImageReady(img));
    });
  }

  function setupInfiniteLoop(sliderEl) {
    clearInfiniteLoop(sliderEl);
    const realItems = Array.from(sliderEl.querySelectorAll('.product-item:not(.product-item--clone)'));
    realCount = realItems.length;
    if (realCount <= 1) {
      loopEnabled = false;
      return;
    }
    loopEnabled = true;
    const beforeFrag = document.createDocumentFragment();
    const afterFrag = document.createDocumentFragment();
    realItems.forEach(function (item) {
      const cloneBefore = item.cloneNode(true);
      prepareLoopClone(cloneBefore, item);
      beforeFrag.appendChild(cloneBefore);
      const cloneAfter = item.cloneNode(true);
      prepareLoopClone(cloneAfter, item);
      afterFrag.appendChild(cloneAfter);
    });
    sliderEl.insertBefore(beforeFrag, sliderEl.firstChild);
    sliderEl.appendChild(afterFrag);
  }

  function clampCarouselIndex(index) {
    if (!loopEnabled || realCount <= 1) {
      return Math.max(0, Math.min(Math.max(realCount - 1, 0), index));
    }
    if (index < 0) return 0;
    if (index > 3 * realCount - 1) return 3 * realCount - 1;
    return index;
  }

  function needsLoopNormalize() {
    if (!loopEnabled || realCount <= 1) return false;
    return currentIndex < realCount || currentIndex >= 2 * realCount;
  }

  function normalizeLoopPosition() {
    if (!loopEnabled || realCount <= 1 || !slider) return false;
    let changed = false;
    while (currentIndex < realCount) {
      currentIndex += realCount;
      changed = true;
    }
    while (currentIndex >= 2 * realCount) {
      currentIndex -= realCount;
      changed = true;
    }
    if (changed) {
      setPositionByIndex(true);
    }
    return changed;
  }

  // Wait for the slide animation to finish before jumping from clones to real items.
  // Calling normalize immediately cancels the last/first slide motion.
  function normalizeLoopAfterTransition() {
    cancelPendingLoopNormalize();
    if (!slider || !needsLoopNormalize()) {
      syncCenterProductColorFromCanonical();
      return;
    }

    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      cancelPendingLoopNormalize();
      normalizeLoopPosition();
      syncCenterProductColorFromCanonical();
    }

    loopNormalizeOnEnd = function (e) {
      if (e.target !== slider) return;
      if (e.propertyName && e.propertyName !== 'transform') return;
      settle();
    };
    slider.addEventListener('transitionend', loopNormalizeOnEnd);
    loopNormalizeTimer = setTimeout(settle, slideTransitionMs);
  }

  function stepCarousel(delta) {
    if (!slider || realCount < 1) return;
    cancelPendingLoopNormalize();
    // Same as dragStart: settle off clones before taking the next step so spam
    // cannot walk past the cloned track into blank / delayed renders.
    if (needsLoopNormalize()) {
      normalizeLoopPosition();
    }
    currentIndex = clampCarouselIndex(currentIndex + delta);
    setPositionByIndex(false);
    normalizeLoopAfterTransition();
  }

  function getStepSize() {
    return isMobileWidth() ? slideWidth : slideWidth + gap;
  }

  function getCenterOffset() {
    return slideWidth / 2 - containerWidth / 2;
  }

  function getTranslateForIndex(index) {
    if (isMobileWidth()) {
      return -(index * slideWidth + getCenterOffset());
    }
    return -(index * getStepSize() + getCenterOffset());
  }

  function getNearestDOMIndex(translate) {
    const step = getStepSize();
    if (step <= 0) return currentIndex;
    return Math.round(-(translate + getCenterOffset()) / step);
  }

  function updateDimensions() {
    if (!slider) return;
    const computedStyle = window.getComputedStyle(slider);
    const parsedGap = parseFloat(computedStyle.gap);
    gap = Number.isFinite(parsedGap) ? parsedGap : 0;
    containerWidth = container.offsetWidth;
    if (containerWidth > 0) {
      container.style.setProperty('--dl-viewport', containerWidth + 'px');
    }
    const firstProductItem = slider.querySelector('.product-item:not(.product-item--clone)');
    slide = firstProductItem ? firstProductItem.querySelector('.product-bg') : null;
    if (isMobileWidth()) {
      const itemWidth = firstProductItem ? firstProductItem.offsetWidth : 0;
      slideWidth = itemWidth > 0 ? itemWidth : containerWidth;
    } else {
      slideWidth = firstProductItem && slide ? firstProductItem.offsetWidth : (slide ? slide.offsetWidth : 0);
    }
    if (slideWidth <= 0 && containerWidth > 0) slideWidth = containerWidth;
  }

  function updateSlider() {
    if (!slider) return;
    slider.style.transform = 'translateX(' + currentTranslate + 'px)';
  }

  function getMobileBounds() {
    const centerOffset = getCenterOffset();
    const minT = -(0 * slideWidth + centerOffset);
    const maxT = -((realCount - 1) * slideWidth + centerOffset);
    return { min: minT, max: maxT };
  }

  function setPositionByIndex(instant) {
    if (!slider || realCount < 1) return;
    updateDimensions();
    if (slideWidth <= 0 || (!isMobileWidth() && containerWidth <= 0)) {
      if (setPositionRetries < maxSetPositionRetries) {
        setPositionRetries += 1;
        requestAnimationFrame(function () { setPositionByIndex(instant); });
      } else if (slider) {
        slider.classList.add('design-list-positioned');
      }
      return;
    }
    setPositionRetries = 0;
    if (instant) slider.style.transition = 'none';
    currentTranslate = getTranslateForIndex(currentIndex);
    prevTranslate = currentTranslate;
    slider.style.filter = 'none';
    slider.style.transform = 'translateX(' + currentTranslate + 'px) scale(1)';
    slider.classList.add('design-list-positioned');
    if (instant) {
      void slider.offsetWidth;
      slider.style.transition = '';
    }
    ensureNearbyProductImages();
    updateNavButtons();
  }

  function markDragFinished() {
    justFinishedDrag = true;
    clearTimeout(justFinishedDragTimer);
    justFinishedDragTimer = setTimeout(function () {
      justFinishedDrag = false;
    }, 350);
  }

  function snapToNearest() {
    if (!slider || realCount < 1) return;
    cancelPendingLoopNormalize();
    updateDimensions();
    currentIndex = clampCarouselIndex(getNearestDOMIndex(currentTranslate));
    setPositionByIndex(false);
    normalizeLoopAfterTransition();
  }

  function updateNavButtons() {
    const panel = getActivePanel();
    if (!panel) return;
    const navLeft = panel.querySelector('.design-list-nav-left');
    const navRight = panel.querySelector('.design-list-nav-right');
    if (navLeft) navLeft.classList.remove('disabled');
    if (navRight) navRight.classList.remove('disabled');
  }

  function getPositionX(event) {
    if (event.type.includes('mouse')) return event.clientX;
    if (event.touches && event.touches[0]) return event.touches[0].clientX;
    return event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
  }

  function getPositionY(event) {
    if (event.type.includes('mouse')) return event.clientY;
    if (event.touches && event.touches[0]) return event.touches[0].clientY;
    return event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : 0;
  }

  function beginDragging() {
    if (!slider || isDragging) return;
    isDragging = true;
    prevTranslate = currentTranslate;
    slider.classList.add('is-dragging');
    slider.style.transition = 'none';
  }

  function onDocumentMouseMove(event) {
    dragMove(event);
  }

  function onDocumentTouchMove(event) {
    dragMove(event);
  }

  function onDocumentTouchEnd() {
    dragEnd();
  }

  function bindDocumentDragListeners() {
    document.addEventListener('mousemove', onDocumentMouseMove);
    document.addEventListener('touchmove', onDocumentTouchMove, { passive: false });
    document.addEventListener('touchend', onDocumentTouchEnd);
    document.addEventListener('touchcancel', onDocumentTouchEnd);
  }

  function unbindDocumentDragListeners() {
    document.removeEventListener('mousemove', onDocumentMouseMove);
    document.removeEventListener('touchmove', onDocumentTouchMove);
    document.removeEventListener('touchend', onDocumentTouchEnd);
    document.removeEventListener('touchcancel', onDocumentTouchEnd);
  }

  function dragStart(event) {
    if (!slider) return;
    if (event.target.closest('.color-option-nav, .color-options-row, .color-options, .color-option, .design-list-nav-button')) {
      event.stopPropagation();
      return;
    }
    if (event.type === 'mousedown' && event.button !== 0) return;
    if (event.type === 'mousedown') event.preventDefault();
    cancelPendingLoopNormalize();
    if (needsLoopNormalize()) {
      normalizeLoopPosition();
    }
    startPos = getPositionX(event);
    startPosY = getPositionY(event);
    dragAxisLocked = null;
    prevTranslate = currentTranslate;
    hasMoved = false;
    isDragging = false;
    isMouseDown = true;
    slider.style.transition = 'none';
    bindDocumentDragListeners();
  }

  function dragMove(event) {
    if (!slider || !isMouseDown) return;
    if (event.type === 'mousemove' && event.buttons === 0) {
      dragEnd();
      return;
    }
    if (event.type === 'touchmove' && (!event.touches || event.touches.length === 0)) {
      dragEnd();
      return;
    }
    const currentPosition = getPositionX(event);
    const currentPositionY = getPositionY(event);
    const moveDistanceX = Math.abs(currentPosition - startPos);
    const moveDistanceY = Math.abs(currentPositionY - startPosY);
    if (moveDistanceX > minMovementToBlockClick || moveDistanceY > minMovementToBlockClick) {
      hasMoved = true;
    }

    if (event.type === 'touchmove' && !dragAxisLocked && (moveDistanceX > touchAxisLockThreshold || moveDistanceY > touchAxisLockThreshold)) {
      dragAxisLocked = moveDistanceX >= moveDistanceY ? 'x' : 'y';
      if (dragAxisLocked === 'y') {
        dragEnd();
        return;
      }
    }

    if (!isDragging && (moveDistanceX > minDragDistance || dragAxisLocked === 'x')) {
      beginDragging();
    }

    if (isDragging) {
      if (event.cancelable) event.preventDefault();
      const dragDistance = (currentPosition - startPos) * sensitivity;
      currentTranslate = prevTranslate + dragDistance;
      if (isMobileWidth() && realCount > 0 && !loopEnabled) {
        const bounds = getMobileBounds();
        currentTranslate = Math.max(bounds.max, Math.min(bounds.min, currentTranslate));
      }
      updateSlider();
    }
  }

  function dragEnd() {
    if (!isMouseDown && !isDragging) {
      unbindDocumentDragListeners();
      return;
    }
    if (!slider) {
      unbindDocumentDragListeners();
      isDragging = false;
      isMouseDown = false;
      dragAxisLocked = null;
      return;
    }
    const wasDragging = isDragging;
    unbindDocumentDragListeners();
    isDragging = false;
    isMouseDown = false;
    dragAxisLocked = null;
    slider.classList.remove('is-dragging');
    slider.style.transition = '';

    slider.style.filter = 'none';
    slider.style.transform = 'translateX(' + currentTranslate + 'px) scale(1)';

    if (realCount < 1) return;

    if (wasDragging) {
      snapToNearest();
    }

    if (wasDragging || hasMoved) markDragFinished();
    hasMoved = false;
  }

  function centerCarousel() {
    setPositionByIndex(false);
  }

  function mountProductSlider() {
    teardownSliderListeners();
    const signal = sliderAbort.signal;
    ensureOneActiveBrandPanel();
    var panel = getActivePanel();
    slider = panel ? panel.querySelector('.products-row') : null;

    if (!slider) {
      sectionEl.querySelectorAll('.brand-panel .products-row').forEach(function (row) {
        row.classList.add('design-list-positioned');
      });
      return;
    }

    setupInfiniteLoop(slider);
    totalSlides = realCount;
    slide = slider.querySelector('.product-bg');
    bindProductImageLoading(slider);

    if (totalSlides < 1) {
      sectionEl.querySelectorAll('.brand-panel .products-row').forEach(function (row) {
        row.classList.add('design-list-positioned');
      });
      return;
    }

    const logicalStart = Math.max(0, Math.floor(realCount / 2));
    currentIndex = loopEnabled ? realCount + logicalStart : logicalStart;
    currentTranslate = 0;
    prevTranslate = 0;
    setPositionRetries = 0;

    const navLeft = panel.querySelector('.design-list-nav-left');
    const navRight = panel.querySelector('.design-list-nav-right');
    if (navLeft) {
      navLeft.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepCarousel(-1);
      }, { signal: signal });
    }
    if (navRight) {
      navRight.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepCarousel(1);
      }, { signal: signal });
    }

    slider.addEventListener('mousedown', dragStart, { passive: false, signal: signal });
    slider.addEventListener('mouseup', dragEnd, { signal: signal });
    document.addEventListener('mouseup', dragEnd, { signal: signal });

    slider.addEventListener('touchstart', dragStart, { passive: false, signal: signal });
    slider.addEventListener('touchend', dragEnd, { signal: signal });
    slider.addEventListener('touchcancel', dragEnd, { signal: signal });

    slider.addEventListener('dragstart', function (e) {
      e.preventDefault();
    }, { signal: signal });

    slider.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    slider.addEventListener('click', function (e) {
      if (justFinishedDrag) {
        if (e.target.closest('.color-option-nav, .color-options-row, .color-options, .color-option')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, { capture: true, signal: signal });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && (isMouseDown || isDragging)) dragEnd();
    }, { signal: signal });

    updateDimensions();
    centerCarousel();
    requestAnimationFrame(centerCarousel);
    setTimeout(function () {
      if (!isMouseDown && !isDragging) centerCarousel();
    }, 100);
    setTimeout(function () {
      if (!isMouseDown && !isDragging) centerCarousel();
    }, 400);
  }

  function selectBrand(brandId) {
    const id = String(brandId);
    currentBrand = id;
    sectionEl.querySelectorAll('.brand-panel').forEach(function (p) {
      p.classList.toggle('is-active', String(p.getAttribute('data-brand-panel')) === id);
    });
    sectionEl.querySelectorAll('[data-brand-tab]').forEach(function (tab) {
      const on = String(tab.getAttribute('data-brand-tab')) === id;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    mountProductSlider();
    layoutBrandSwitcher();
  }

  if (switcher) {
    switcher.querySelectorAll('[data-brand-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectBrand(tab.getAttribute('data-brand-tab'));
      }, mainSignal);
    });
    const prevBtn = switcher.querySelector('.brand-switcher-nav--prev');
    const nextBtn = switcher.querySelector('.brand-switcher-nav--next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        const ids = getBrandTabIds();
        if (!ids.length) return;
        const n = ids.length;
        const i = ids.indexOf(currentBrand);
        const idx = i < 0 ? 0 : i;
        selectBrand(ids[(idx - 1 + n) % n]);
      }, mainSignal);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const ids = getBrandTabIds();
        if (!ids.length) return;
        const n = ids.length;
        const i = ids.indexOf(currentBrand);
        const idx = i < 0 ? 0 : i;
        selectBrand(ids[(idx + 1) % n]);
      }, mainSignal);
    }
    layoutBrandSwitcher();
    const labelsForRo = switcher.querySelector('.brand-switcher-labels');
    if (labelsForRo && typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(function () {
        layoutBrandSwitcher();
      });
      ro.observe(labelsForRo);
      lastResizeObserver = ro;
      syncInstance();
    }
  }

  let resizeRAF = 0;
  window.addEventListener('resize', function () {
    if (isMouseDown || isDragging) dragEnd();
    if (resizeRAF) cancelAnimationFrame(resizeRAF);
    resizeRAF = requestAnimationFrame(function () {
      resizeRAF = 0;
      layoutBrandSwitcher();
      if (!isMouseDown && !isDragging) setPositionByIndex(false);
    });
  }, mainSignal);

  window.addEventListener('load', function () {
    if (!isMouseDown && !isDragging) centerCarousel();
    layoutBrandSwitcher();
  }, mainSignal);

  function setActiveColorOption(li) {
    if (!li) return;
    const group = li.closest('.color-options');
    if (!group) return;
    group.querySelectorAll('.color-option').forEach(function (option) { option.classList.remove('is-active'); });
    li.classList.add('is-active');
    if (group.scrollWidth > group.clientWidth + 1) {
      var left = li.offsetLeft - (group.clientWidth / 2) + (li.offsetWidth / 2);
      group.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  function getProductItemId(productItem) {
    const bg = productItem ? productItem.querySelector('.product-bg[data-product-id]') : null;
    return bg ? String(bg.getAttribute('data-product-id') || '') : '';
  }

  function getCanonicalProductItem(productId) {
    if (!productId || !slider) return null;
    const items = slider.querySelectorAll('.product-item:not(.product-item--clone)');
    for (let i = 0; i < items.length; i += 1) {
      if (getProductItemId(items[i]) === productId) return items[i];
    }
    return null;
  }

  var boundProductImages = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var imageWatchTimers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function setProductImageLoading(productBg, isLoading) {
    if (!productBg) return;
    var loading = !!isLoading;
    productBg.classList.toggle('is-loading', loading);
    // Keep swatches gated with the image so they appear together when load finishes.
    var productItem = productBg.closest('.product-item');
    if (productItem) productItem.classList.toggle('is-loading', loading);
  }

  function isImageReady(img) {
    return !!(img && img.complete && img.naturalWidth > 0);
  }

  function clearImageWatch(img) {
    if (!img) return;
    if (imageWatchTimers && imageWatchTimers.has(img)) {
      clearTimeout(imageWatchTimers.get(img));
      imageWatchTimers.delete(img);
    } else if (img.dataset && img.dataset.dlmWatchTimer) {
      clearTimeout(Number(img.dataset.dlmWatchTimer));
      delete img.dataset.dlmWatchTimer;
    }
  }

  function armImageWatch(img, onTimeout) {
    clearImageWatch(img);
    var timer = setTimeout(onTimeout, 2200);
    if (imageWatchTimers) {
      imageWatchTimers.set(img, timer);
    } else if (img.dataset) {
      img.dataset.dlmWatchTimer = String(timer);
    }
  }

  function isImageWatching(img) {
    if (!img) return false;
    if (imageWatchTimers) return imageWatchTimers.has(img);
    return !!(img.dataset && img.dataset.dlmWatchTimer);
  }

  // Transform-based carousels skip the scroll viewport, so native lazy-load
  // never starts. Force eager; restart the request only when needed.
  function kickImageRequest(img, src, forceRestart) {
    if (!img) return '';
    var nextSrc = src || img.getAttribute('src') || img.currentSrc || '';
    img.setAttribute('loading', 'eager');
    img.removeAttribute('fetchpriority');
    if (!nextSrc) return '';
    var currentAttr = img.getAttribute('src') || '';
    if (currentAttr !== nextSrc) {
      img.src = nextSrc;
      img.dataset.dlmKicked = '1';
    } else if (!isImageReady(img) && (forceRestart || img.dataset.dlmKicked !== '1')) {
      img.removeAttribute('src');
      img.src = nextSrc;
      img.dataset.dlmKicked = '1';
    }
    return nextSrc;
  }

  function settleProductImage(img) {
    if (!img) return;
    clearImageWatch(img);
    setProductImageLoading(img.closest('.product-bg'), false);
  }

  function revealWhenReady(img, token) {
    if (!img) return false;
    if (token != null && String(img.dataset.dlmLoadToken || '') !== String(token)) return false;
    if (isImageReady(img)) {
      settleProductImage(img);
      return true;
    }
    return false;
  }

  function watchUntilReady(img, token) {
    var productBg = img ? img.closest('.product-bg') : null;
    if (!img || !productBg) return;

    if (revealWhenReady(img, token)) return;

    // Already waiting on this image — don't stack listeners / restart src.
    if (isImageWatching(img)) {
      if (token == null || String(img.dataset.dlmLoadToken || '') === String(token)) return;
      clearImageWatch(img);
    }

    setProductImageLoading(productBg, true);
    kickImageRequest(img, null, false);

    if (revealWhenReady(img, token)) return;

    function onLoad() {
      revealWhenReady(img, token);
    }
    function onError() {
      if (token != null && String(img.dataset.dlmLoadToken || '') !== String(token)) return;
      var src = img.getAttribute('src') || '';
      if (src && img.dataset.dlmRetried !== '1') {
        img.dataset.dlmRetried = '1';
        kickImageRequest(img, src, true);
        armImageWatch(img, onWatchTimeout);
        return;
      }
      settleProductImage(img);
    }
    function onWatchTimeout() {
      if (token != null && String(img.dataset.dlmLoadToken || '') !== String(token)) return;
      if (revealWhenReady(img, token)) return;
      var src = img.getAttribute('src') || '';
      if (src && img.dataset.dlmRetried !== '1') {
        img.dataset.dlmRetried = '1';
        kickImageRequest(img, src, true);
        armImageWatch(img, onWatchTimeout);
        return;
      }
      settleProductImage(img);
    }

    img.addEventListener('load', onLoad, { once: true });
    img.addEventListener('error', onError, { once: true });
    if (typeof img.decode === 'function') {
      // Only settle on successful decode. Rejects must NOT clear loading —
      // that was leaving empty boxes when lazy loads never started.
      img.decode().then(function () {
        revealWhenReady(img, token);
      }).catch(function () { /* wait for load/error/timeout */ });
    }
    armImageWatch(img, onWatchTimeout);
  }

  function bindProductImageLoading(root) {
    var scope = root || sectionEl;
    if (!scope) return;
    scope.querySelectorAll('.product-bg img.product-bg-img').forEach(function (img) {
      if (boundProductImages) {
        if (boundProductImages.has(img)) {
          if (!isImageReady(img) && img.closest('.product-bg.is-loading')) {
            watchUntilReady(img, img.dataset.dlmLoadToken);
          }
          return;
        }
        boundProductImages.add(img);
      } else if (img.dataset.dlmLoadBound === '1') {
        if (!isImageReady(img) && img.closest('.product-bg.is-loading')) {
          watchUntilReady(img, img.dataset.dlmLoadToken);
        }
        return;
      } else {
        img.dataset.dlmLoadBound = '1';
      }

      img.addEventListener('load', function () {
        settleProductImage(img);
      });
      img.addEventListener('error', function () {
        watchUntilReady(img, img.dataset.dlmLoadToken);
      });

      if (isImageReady(img)) {
        settleProductImage(img);
      } else {
        watchUntilReady(img, img.dataset.dlmLoadToken);
      }
    });
  }

  function sameImageUrl(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    try {
      return new URL(a, window.location.href).href === new URL(b, window.location.href).href;
    } catch (e) {
      return false;
    }
  }

  function loadProductImage(img, src) {
    if (!img || !src) return;
    var productBg = img.closest('.product-bg');
    var current = img.currentSrc || img.getAttribute('src') || '';
    if ((sameImageUrl(current, src) || sameImageUrl(img.getAttribute('src'), src)) && isImageReady(img)) {
      settleProductImage(img);
      return;
    }

    var token = (Number(img.dataset.dlmLoadToken) || 0) + 1;
    img.dataset.dlmLoadToken = String(token);
    delete img.dataset.dlmRetried;
    delete img.dataset.dlmKicked;
    clearImageWatch(img);

    setProductImageLoading(productBg, true);
    img.style.width = 'auto';
    img.style.height = 'auto';
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    kickImageRequest(img, src, true);
    watchUntilReady(img, token);
  }

  function applyColorIndexToProductItem(productItem, activeIndex, colorSrc) {
    if (!productItem) return;
    const itemOptions = productItem.querySelectorAll('.color-options .color-option');
    if (activeIndex < 0 || activeIndex >= itemOptions.length) return;
    const targetLi = itemOptions[activeIndex];
    const mainImg = productItem.querySelector('.product-bg img');
    const src = colorSrc || targetLi.dataset.color;
    if (mainImg && src) {
      loadProductImage(mainImg, src);
    }
    setActiveColorOption(targetLi);
  }

  function syncProductColorFromItem(sourceItem) {
    if (!sourceItem || !slider) return;
    const productId = getProductItemId(sourceItem);
    if (!productId) return;
    const options = sourceItem.querySelectorAll('.color-options .color-option');
    let activeIndex = Array.from(options).findIndex(function (el) { return el.classList.contains('is-active'); });
    if (activeIndex < 0) activeIndex = 0;
    const activeOption = options[activeIndex];
    const colorSrc = activeOption ? activeOption.dataset.color : '';
    slider.querySelectorAll('.product-item').forEach(function (item) {
      if (getProductItemId(item) !== productId) return;
      applyColorIndexToProductItem(item, activeIndex, colorSrc);
    });
  }

  function syncActiveColorClassFromItem(sourceItem) {
    if (!sourceItem || !slider) return;
    const productId = getProductItemId(sourceItem);
    if (!productId) return;
    const options = sourceItem.querySelectorAll('.color-options .color-option');
    let activeIndex = Array.from(options).findIndex(function (el) { return el.classList.contains('is-active'); });
    if (activeIndex < 0) activeIndex = 0;
    slider.querySelectorAll('.product-item').forEach(function (item) {
      if (getProductItemId(item) !== productId) return;
      const itemOptions = item.querySelectorAll('.color-options .color-option');
      if (activeIndex >= 0 && activeIndex < itemOptions.length) {
        setActiveColorOption(itemOptions[activeIndex]);
      }
    });
  }

  function ensureItemImageFromCanonical(item) {
    if (!item) return;
    const canonical = getCanonicalProductItem(getProductItemId(item));
    const itemImg = item.querySelector('.product-bg img.product-bg-img');
    if (!itemImg) return;

    if (canonical) {
      const canonicalImg = canonical.querySelector('.product-bg img.product-bg-img');
      if (canonicalImg) {
        var src = canonicalImg.currentSrc || canonicalImg.getAttribute('src') || '';
        if (src) {
          if (isImageReady(itemImg) && sameImageUrl(itemImg.currentSrc || itemImg.getAttribute('src'), src)) {
            settleProductImage(itemImg);
          } else {
            loadProductImage(itemImg, src);
          }
        }
      }
      if (item !== canonical) syncActiveColorClassFromItem(canonical);
      return;
    }

    // No canonical match — still kick a stalled loader so it cannot stay empty.
    if (isImageReady(itemImg)) settleProductImage(itemImg);
    else watchUntilReady(itemImg, itemImg.dataset.dlmLoadToken);
  }

  // Keep center + neighbors painted immediately so rapid Next clicks never wait
  // on transitionend / lazy-load settle. Copy the already-rendered canonical
  // image instead of re-applying data-color URLs (avoids loading flashes).
  function ensureNearbyProductImages() {
    if (!slider || realCount < 1) return;
    const items = slider.querySelectorAll('.product-item');
    for (var offset = -1; offset <= 1; offset += 1) {
      ensureItemImageFromCanonical(items[currentIndex + offset]);
    }
    // Also rescue any visible stuck loaders in the active track.
    slider.querySelectorAll('.product-bg.is-loading img.product-bg-img').forEach(function (img) {
      if (!isImageReady(img)) watchUntilReady(img, img.dataset.dlmLoadToken);
      else settleProductImage(img);
    });
  }

  function syncCenterProductColorFromCanonical() {
    ensureNearbyProductImages();
  }

  function applyColorOptionToProduct(li) {
    if (!li || !slider) return;
    const productItem = li.closest('.product-item');
    if (!productItem) return;
    const options = productItem.querySelectorAll('.color-options .color-option');
    const activeIndex = Array.from(options).indexOf(li);
    if (activeIndex < 0) return;
    const colorSrc = li.dataset.color || '';
    slider.querySelectorAll('.product-item').forEach(function (item) {
      if (getProductItemId(item) !== getProductItemId(productItem)) return;
      applyColorIndexToProductItem(item, activeIndex, colorSrc);
    });
  }

  function cycleColorOption(productItem, direction) {
    if (!productItem) return;
    const canonical = productItem.classList.contains('product-item--clone')
      ? getCanonicalProductItem(getProductItemId(productItem))
      : productItem;
    if (!canonical) return;
    const options = Array.from(canonical.querySelectorAll('.color-options .color-option'));
    if (options.length <= 1) return;
    let idx = options.findIndex(function (el) { return el.classList.contains('is-active'); });
    if (idx < 0) idx = 0;
    idx = (idx + direction + options.length) % options.length;
    applyColorOptionToProduct(options[idx]);
  }

  function saveDesignListBreadcrumbTrail() {
    if (document.querySelector('[data-breadcrumb-save]')) return;
    var panel = getActivePanel();
    if (window.ThreeCitiesDesignBreadcrumb && typeof window.ThreeCitiesDesignBreadcrumb.saveFromClickTarget === 'function') {
      window.ThreeCitiesDesignBreadcrumb.saveFromClickTarget(panel);
      return;
    }
    var url = panel ? panel.getAttribute('data-breadcrumb-url') : '';
    var label = panel ? panel.getAttribute('data-breadcrumb-label') : '';
    if (!url || !label) return;
    try {
      sessionStorage.setItem('3cd_breadcrumb_trail', JSON.stringify({ url: url, label: label }));
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function resolveCanonicalProductItem(productItem) {
    if (!productItem) return null;
    if (!productItem.classList.contains('product-item--clone')) return productItem;
    var productId = getProductItemId(productItem);
    var row = productItem.closest('.products-row');
    if (!row || !productId) return productItem;
    var items = row.querySelectorAll('.product-item:not(.product-item--clone)');
    for (var i = 0; i < items.length; i += 1) {
      if (getProductItemId(items[i]) === productId) return items[i];
    }
    return productItem;
  }

  function getProductNavUrl(productItem) {
    var item = resolveCanonicalProductItem(productItem);
    if (!item) return '';
    var activeColorOption = item.querySelector('.color-option.is-active');
    if (activeColorOption && activeColorOption.dataset.productUrl) {
      return activeColorOption.dataset.productUrl;
    }
    var opts = item.querySelectorAll('.color-option');
    for (var o = 0; o < opts.length; o += 1) {
      if (opts[o].dataset.productUrl) return opts[o].dataset.productUrl;
    }
    return '';
  }

  function navigateToDesignListProduct(productItem) {
    var url = getProductNavUrl(productItem);
    if (!url) return;
    saveDesignListBreadcrumbTrail();
    window.location.href = url;
  }

  sectionEl.addEventListener('click', function (e) {
    var nav = e.target.closest('.color-option-nav');
    if (nav && sectionEl.contains(nav)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var productItem = nav.closest('.product-item');
      if (!productItem) return;
      cycleColorOption(productItem, nav.classList.contains('color-option-nav--next') ? 1 : -1);
      return;
    }
    var li = e.target.closest('.color-options .color-option');
    if (!li || !sectionEl.contains(li)) return;
    if (justFinishedDrag) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    applyColorOptionToProduct(li);
  }, { capture: true, signal: mainAbort.signal });

  sectionEl.addEventListener('click', function (e) {
    var linked = e.target.closest('a.design-item--linked');
    if (linked && sectionEl.contains(linked)) {
      if (justFinishedDrag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      saveDesignListBreadcrumbTrail();
      return;
    }

    var productHit = e.target.closest('.product-bg, .product-name');
    if (!productHit || !sectionEl.contains(productHit)) return;
    if (e.target.closest('.color-options, .color-option-nav')) return;

    if (justFinishedDrag) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    var productItem = productHit.closest('.product-item');
    if (!productItem) return;
    e.preventDefault();
    e.stopPropagation();
    navigateToDesignListProduct(productItem);
  }, mainSignal);

  const designListContent = sectionEl.querySelector('.design-list-content');
  const designListReveal = sectionEl.querySelector('.design-list__reveal');
  let wasInView = false;

  function bindDesignListScrollReveal() {
    if (!designListReveal) return;
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      designListReveal.classList.add('visible');
    }
    setTimeout(reveal, 900);
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal();
      } else if ('IntersectionObserver' in window) {
        var obsRoot = designListReveal;
        var dlIo = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              reveal();
              dlIo.disconnect();
            }
          });
        }, { root: null, rootMargin: '80px 0px 80px 0px', threshold: 0.01 });
        dlIo.observe(obsRoot);
      } else {
        reveal();
      }
    } catch (e) {
      reveal();
    }
  }
  bindDesignListScrollReveal();

  function checkScroll() {
    if (!designListContent || !designListReveal) return;

    const sectionTop = designListContent.getBoundingClientRect().top;
    const sectionBottom = designListContent.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;
    const isInView = sectionTop < windowHeight && sectionBottom > 0;

    if (!wasInView && isInView && totalSlides > 0) {
      const logicalStart = Math.max(0, Math.floor(totalSlides / 2));
      currentIndex = loopEnabled ? realCount + logicalStart : logicalStart;
      setPositionByIndex(false);
      normalizeLoopPosition();
    }

    wasInView = isInView;
  }

  bindProductImageLoading(sectionEl);
  mountProductSlider();
  layoutBrandSwitcher();
  checkScroll();
  window.addEventListener('scroll', checkScroll, mainSignal);

  if (typeof document !== 'undefined' && document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      layoutBrandSwitcher();
      setPositionByIndex(false);
    });
  }
  }

  function initAllDesignListMultiple() {
    document.querySelectorAll('[data-design-list-multiple][data-section-id]').forEach(function (el) {
      initDesignListMultiple(el.getAttribute('data-section-id'));
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (!sid) return;
    if (document.querySelector('#shopify-section-' + sid + ' [data-design-list-multiple]')) {
      initDesignListMultiple(sid);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (sid) teardownInstance(sid);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDesignListMultiple, { once: true });
  } else {
    initAllDesignListMultiple();
  }
})();
